import { Platform } from 'react-native'

import { defaultLocale, locales } from '@/translations/translations.constants'

let currentLocale = 'en'
if (Intl.Locale) {
  const { getLocales } = require('expo-localization')
  currentLocale = getLocales().at(0)?.languageCode || 'en'
} else if (Platform.OS === 'web') {
  currentLocale = navigator.language.substring(0, 2)
}

export const isSupportedLocale = (locale?: string | null): locale is TLocale =>
  !!locale && (locales as readonly string[]).includes(locale)

export const getLocale = (): TLocale => (isSupportedLocale(currentLocale) ? currentLocale : defaultLocale)
